import { Note } from '../models/note.model';
import { VehicleIcons, VehicleTypes } from '../models/vehicle-types.model';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Vehicle } from '../models/api/vehicle.model';
import { map } from 'rxjs/operators';
import { DropdownOption } from '../models/dropdown-option';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}
  private readonly urlVehicles = environment.baseUrl +  environment.api + 'vehicles'  + environment.surfix;

  public vehicleTypesOptions: DropdownOption[] = [
    { label: 'vehicles.filter.type.all', value: VehicleTypes.ALL.toString() },
    { label: 'vehicles.filter.type.car', value: VehicleTypes.CAR.toString() },
    { label: 'vehicles.filter.type.other', value: VehicleTypes.OTHER.toString(), },
  ];
  static prepareIconSrc(iconType: VehicleIcons): string {
    const prefix = './assets/vehicles/';
    return prefix + iconType + '.png';
  }

  getVehiclesList() {
    return this.httpClient
      .get<Vehicle[]>(this.urlVehicles + '/sensors', {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((vehicles) => {
          vehicles.forEach((vehicle) => {
            if (
              vehicle.custom_description == null ||
              vehicle.custom_description === ''
            ) {
              vehicle.custom_description = vehicle.description;
            }
          });
          return vehicles;
        })
      );
  }

  sanitizeVehicleType(type: string): string {
          type = VehicleIcons.PHARMACY;
    const isIconType = Object.values(VehicleIcons).some(
      (icon) => icon === type
    );
    const iconName = isIconType ? type : VehicleIcons.PASSENGER;
    return VehiclesService.prepareIconSrc(iconName as VehicleIcons);
  }


  saveNote(vehicleId: string, noteValue: string) {
    return this.httpClient.put<Note>(
      this.urlVehicles + vehicleId + '/note',
      noteValue,
      { headers: this.authService.getJwtAuthHeaders() }
    );
  }
}
